import React, { useEffect } from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { ReactComponent as BracketLeft } from '../../../assets/icons/calculator-bracket-left.svg';
import { ReactComponent as BracketRight } from '../../../assets/icons/calculator-bracket-right.svg';
import { ReactComponent as MessagesIcon } from '../../../assets/icons/messages-filled.svg';
import { DarkButton } from 'components/Buttons';
const unreadMessagesCount = gql`
  query unreadMessagesCount {
    unreadMessagesCount
  }
`;

const UnreadMessagesCard = ({ history }: RouteComponentProps) => {
  const { data, startPolling, stopPolling } = useQuery(unreadMessagesCount);

  useEffect(() => {
    startPolling(60000);

    return () => stopPolling();
  }, [startPolling, stopPolling]);

  if (!data || !data.unreadMessagesCount) {
    return null;
  }

  const count = data.unreadMessagesCount;
  return (
    <YellowCard>
      <FlexWrapper>
        <SvgContainer>
          <BracketLeft />
          <MessagesIcon />
          <BracketRight />
        </SvgContainer>
        <Text>
          You have {count} unread message{count > 1 ? 's' : ''}
        </Text>
      </FlexWrapper>
      <DarkButton onClick={() => history.push('/messages')}>View Messages</DarkButton>
    </YellowCard>
  );
};

export default withRouter(UnreadMessagesCard);

const YellowCard = styled.div`
  ${({ theme }) => theme.fonts.DomaineDisplay}
  background-color: ${({ theme }) => theme.colors.yellow};
  font-size: 1.5em;
  padding: 0.75em;
  margin-bottom: 1em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    flex-direction: row;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    flex-direction: row;
  }
`;

const SvgContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
  height: 24px;

  svg:first-of-type,
  svg:last-of-type {
    width: 18px;
    path {
      fill: white;
    }
  }
`;

const Text = styled.div`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    margin: 10px;
  }
`;
